<template>
  <div class="bg-color__fff ">
    <div class="top-title__tips">
      <span class="title">{{ title }}</span>
      <el-button
        size="98"
        class="fff-color"
        round
        v-permission:export="$route.meta.permission"
        >导出
      </el-button>
    </div>
    <slot />
  </div>
</template>
<script>
export default {
  name: 'Block',
  props: {
    title: {
      type: String
    }
  }
}
</script>
<style lang="scss">
.data-analysis {
  display: flex;
  flex-wrap: wrap;
  min-width: calc(1920px - 1.3rem);
  width: calc(100% - 1.3rem);
  margin-right: 0;
  .winner-flex {
    height: calc(100% - 33px - 3.2rem);
  }
  .ve-ring {
    top: 0;
  }
  > div {
    margin: 0 1.3rem 1.3rem 0;
  }
  .top-title__tips {
    display: flex;
    padding: 1.6rem 0;
    margin: 0 2.3rem;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid colors('bor-main');
    font-size: 0.9rem;
    font-weight: bold;
  }

  .chart-line {
    position: relative;
    height: 38.8rem;
    .chang-data {
      position: absolute;
      top: 4rem;
      left: 50%;
      transform: translateX(-50%);
      z-index: 200;
    }

    .time {
      position: absolute;
      top: 6rem;
      right: 2.4rem;
    }
    .dot {
      @include dots(#4a4a4a, -1rem, 6px);

      &:nth-child(1) {
        margin-right: 3rem;

        &:before {
          background-color: colors('bg-sub');
        }
      }
    }

    .avage-price {
      position: absolute;
      bottom: 5rem;
      left: 0;
      right: 0;
      width: 100%;
      text-align: center;

      .price {
        margin-bottom: 0.9rem;

        &:nth-child(2) {
          .dot {
            &:before {
              background-color: colors('a4');
            }
          }
        }
      }

      .dot {
        margin-right: 1rem;
        @include dots(#ff3649, -1rem, 6px);
      }
    }
  }

  .list-item {
    .item {
      display: flex;
      margin-bottom: 1.9rem;
      align-items: center;
      &:nth-child(1) {
        .progress {
          background-color: colors('bg-sub');
        }
      }
      &:nth-child(2) {
        .progress {
          background-color: colors('bg-sub');
        }
      }
      &:nth-child(3) {
        .progress {
          background-color: colors('bg-sub');
        }
      }
      &:last-child {
        margin: 0;
      }
    }

    .block {
      width: 16.6rem;
      height: 1.3rem;
      line-height: 1.3rem;
      margin: 0 2.2rem 0 1.9rem;
    }

    .progress {
      width: 100%;
      height: 100%;
      border-radius: 0 0.9rem 0.9rem 0;
      color: #fff;
      background-color: #dcc4a1;
      span {
        padding-left: 0.3rem;
      }
    }
    .name,
    .num {
      width: 8rem;
      white-space: nowrap;
    }
    .name {
      text-align: right;
    }
    .num {
      text-align: left;
    }
  }
}
</style>
